import { render, staticRenderFns } from "./notes-universal-audio.vue?vue&type=template&id=08725a12"
import script from "./notes-universal-audio.vue?vue&type=script&lang=ts"
export * from "./notes-universal-audio.vue?vue&type=script&lang=ts"
import style0 from "./notes-universal-audio.vue?vue&type=style&index=0&id=08725a12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports